/* eslint-disable */
import React from 'react';
import * as MUI from '@material-ui/core';
import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 'fit-content',
      width: '100%',
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      display: "flex",
      flexShrink: 0,
      flexDirection: 'column',
      flex: "none",
      boxSizing: 'border-box',
      background: theme.palette.common.white
    },
  }));

export type Props = { children: any };

export function ReportLayout(props: Props) {
  const classes = useStyles(props);
  return (<>
    <MUI.Box className={classes.root} id="report-layout">
      {props.children}
    </MUI.Box>
  </>);
}

export default ReportLayout;
